import { useFormContext, useWatch } from 'react-hook-form';

import { MealNutrientsInfo, MealPlansMacrosFormValues } from '../../interfaces/MealPlan';
import { REGULAR_MEAL_NAME } from '../../../shared/constants/mealNames';

export const useNutrientsTotal = (nameIndex: number) => {
  const { control } = useFormContext<MealPlansMacrosFormValues>();

  // Adds up all six meals on purpose, including Snack1, which 5-meal plans hide.
  // The backend saves the total the same way, so both always show the same number.
  // On 5-meal plans the backend keeps Snack1 at 0. If Total is higher than the visible
  // rows, the backend data is wrong: fix it there, don't hide it here (LMP-5527).
  const meals = useWatch({
    control,
    name: Object.values(REGULAR_MEAL_NAME).map(
      (meal) => `mealPlans.${nameIndex}.${meal}` as const,
    ),
  });

  const total = meals.reduce<MealNutrientsInfo>(
    (acc, meal) => {
      Object.keys(acc).forEach((nutrient) => {
        const nutrientKey = nutrient as keyof MealNutrientsInfo;

        acc[nutrientKey] += meal[nutrientKey] || 0;
      });
      return acc;
    },
    { calories: 0, proteins: 0, carbs: 0, fats: 0 },
  );

  return total;
};
